export function findClosestPrecedingDate(
    targetDate: number | string | undefined | null, 
    availableDates: (number | string)[], 
    frequency?: number | undefined | null
): number | undefined {
    if (targetDate === undefined || targetDate === null) return;

    const searchedFrequency = (frequency || frequency == 0) ? frequency : +String(targetDate)[0];
    const availableDatesForFrequency = availableDates.filter(date => +String(date)[0] === searchedFrequency).map(Number);
    const tergetDateWithSearchedfrequency = Number(searchedFrequency + String(targetDate).slice(1));
    if (availableDatesForFrequency.length === 0) return;
    let closestDate: number | undefined = undefined;
    
    for (const date of availableDatesForFrequency) {
        if (date <= tergetDateWithSearchedfrequency) {
            if (!closestDate) {
                closestDate = date;
            } else if (tergetDateWithSearchedfrequency - date < tergetDateWithSearchedfrequency - closestDate) {
                closestDate = date;
            }
        }
    }
    return closestDate;
};

export function getDateWithoutFrequency(date: number | string): number {
    return +String(date).slice(1);
};

export function getDateParts(date: number | string): {
    frequency: string;
    year: string;
    month: string;
    day: string;
} {
    return {
        frequency: String(date)[0],
        year: String(date).slice(1,5),
        month: String(date).slice(5, 7),
        day: String(date).slice(7, 9),
    }
}

export function getDateId(date: Date, frequency: number): number {
    const monthIndex = date.getMonth() + 1;
    const month = monthIndex > 9 ? monthIndex.toString() : "0" + monthIndex.toString();
    const day = date.getDate() > 9 ? date.getDate().toString() : "0" + date.getDate().toString();
    return Number(`${frequency}${date.getFullYear()}${month}${day}`);
}

export function getCurrentYear() {
    return +`1${new Date().getFullYear()}0101`;
}